var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("br"),
    _vm._v(" "),
    _vm.levelIndustry && _vm.levelIndustry > 0.8
      ? _c("span", { staticClass: "comparison" }, [
          _vm._v("\n        Andere "),
          _c("strong", [_vm._v("Unternehmen Ihrer Branche")]),
          _vm._v(" haben durchschnittlich einen KI-Readiness-Level von "),
          _c("span", { staticStyle: { "font-weight": "bold" } }, [
            _vm._v(_vm._s(_vm.levelIndustry) + " Sternen erreicht: ")
          ]),
          _c("br"),
          _vm._v(" "),
          _c("div", { staticClass: "stars-wrapper" }, [
            _vm.levelIndustry >= 0.5
              ? _c("img", {
                  staticClass: "star-small",
                  attrs: {
                    src: require("../../../../assets/star.svg"),
                    alt: "Star",
                    width: "15",
                    height: "15"
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.levelIndustry >= 1.5
              ? _c("img", {
                  staticClass: "star-small",
                  attrs: {
                    src: require("../../../../assets/star.svg"),
                    alt: "Star",
                    width: "15",
                    height: "15"
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.levelIndustry >= 2.5
              ? _c("img", {
                  staticClass: "star-small",
                  attrs: {
                    src: require("../../../../assets/star.svg"),
                    alt: "Star",
                    width: "15",
                    height: "15"
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.levelIndustry >= 3.5
              ? _c("img", {
                  staticClass: "star-small",
                  attrs: {
                    src: require("../../../../assets/star.svg"),
                    alt: "Star",
                    width: "15",
                    height: "15"
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.levelIndustry >= 4.5
              ? _c("img", {
                  staticClass: "star-small",
                  attrs: {
                    src: require("../../../../assets/star.svg"),
                    alt: "Star",
                    width: "15",
                    height: "15"
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.levelIndustry < 1.5
              ? _c("img", {
                  staticClass: "star-small",
                  attrs: {
                    src: require("../../../../assets/star_gray.svg"),
                    alt: "Star",
                    width: "15",
                    height: "15"
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.levelIndustry < 2.5
              ? _c("img", {
                  staticClass: "star-small",
                  attrs: {
                    src: require("../../../../assets/star_gray.svg"),
                    alt: "Star",
                    width: "15",
                    height: "15"
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.levelIndustry < 3.5
              ? _c("img", {
                  staticClass: "star-small",
                  attrs: {
                    src: require("../../../../assets/star_gray.svg"),
                    alt: "Star",
                    width: "15",
                    height: "15"
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.levelIndustry < 4.5
              ? _c("img", {
                  staticClass: "star-small",
                  attrs: {
                    src: require("../../../../assets/star_gray.svg"),
                    alt: "Star",
                    width: "15",
                    height: "15"
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.levelIndustry < 0.5
              ? _c("img", {
                  staticClass: "star-small",
                  attrs: {
                    src: require("../../../../assets/star_gray.svg"),
                    alt: "Star",
                    width: "15",
                    height: "15"
                  }
                })
              : _vm._e(),
            _c("br")
          ])
        ])
      : _c("span", { staticClass: "comparison" }, [
          _vm._v(
            "\n        Es gibt nicht genügend Unternehmen in Ihrer Branche, um einen Vergleich zu ziehen.\n    "
          )
        ]),
    _vm._v(" "),
    _c("br"),
    _vm._v(" "),
    _vm.levelSize && _vm.levelSize > 0.2
      ? _c("span", { staticClass: "comparison" }, [
          _vm._v("\n        Andere "),
          _c("strong", [_vm._v("Unternehmen Ihrer Größe")]),
          _vm._v(" haben durchschnittlich einen KI-Readiness-Level von "),
          _c("span", { staticStyle: { "font-weight": "bold" } }, [
            _vm._v(_vm._s(_vm.levelSize) + " Sternen erreicht: ")
          ]),
          _c("br"),
          _vm._v(" "),
          _c("div", { staticClass: "stars-wrapper" }, [
            _vm.levelSize >= 0.5
              ? _c("img", {
                  staticClass: "star-small",
                  attrs: {
                    src: require("../../../../assets/star.svg"),
                    alt: "Star",
                    width: "15",
                    height: "15"
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.levelSize >= 1.5
              ? _c("img", {
                  staticClass: "star-small",
                  attrs: {
                    src: require("../../../../assets/star.svg"),
                    alt: "Star",
                    width: "15",
                    height: "15"
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.levelSize >= 2.5
              ? _c("img", {
                  staticClass: "star-small",
                  attrs: {
                    src: require("../../../../assets/star.svg"),
                    alt: "Star",
                    width: "15",
                    height: "15"
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.levelSize >= 3.5
              ? _c("img", {
                  staticClass: "star-small",
                  attrs: {
                    src: require("../../../../assets/star.svg"),
                    alt: "Star",
                    width: "15",
                    height: "15"
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.levelSize >= 4.5
              ? _c("img", {
                  staticClass: "star-small",
                  attrs: {
                    src: require("../../../../assets/star.svg"),
                    alt: "Star",
                    width: "15",
                    height: "15"
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.levelSize < 1.5
              ? _c("img", {
                  staticClass: "star-small",
                  attrs: {
                    src: require("../../../../assets/star_gray.svg"),
                    alt: "Star",
                    width: "15",
                    height: "15"
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.levelSize < 2.5
              ? _c("img", {
                  staticClass: "star-small",
                  attrs: {
                    src: require("../../../../assets/star_gray.svg"),
                    alt: "Star",
                    width: "15",
                    height: "15"
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.levelSize < 3.5
              ? _c("img", {
                  staticClass: "star-small",
                  attrs: {
                    src: require("../../../../assets/star_gray.svg"),
                    alt: "Star",
                    width: "15",
                    height: "15"
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.levelSize < 4.5
              ? _c("img", {
                  staticClass: "star-small",
                  attrs: {
                    src: require("../../../../assets/star_gray.svg"),
                    alt: "Star",
                    width: "15",
                    height: "15"
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.levelSize < 0.5
              ? _c("img", {
                  staticClass: "star-small",
                  attrs: {
                    src: require("../../../../assets/star_gray.svg"),
                    alt: "Star",
                    width: "15",
                    height: "15"
                  }
                })
              : _vm._e(),
            _c("br")
          ])
        ])
      : _c("span", { staticClass: "comparison" }, [
          _vm._v(
            "\n        Es gibt nicht genügend Unternehmen in Ihrer Unternehmensgröße, um einen Vergleich zu ziehen.\n    "
          )
        ]),
    _vm._v(" "),
    _c("span", { staticStyle: { "font-size": "small" } }, [
      _vm._v(
        "Basiert auf Auswertung von insgesamt " +
          _vm._s(_vm.amountCompaniesComparison) +
          "\n        Unternehmen."
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-60f353a4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60f353a4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/company/kirc/components/Comparison.vue
// module id = null
// module chunks = 